<template>
  <div class="formulaire">
  <form id="formulaire"
    @submit="checkForm"
    action="SendMail()"
    method="post">

      <div v-if="errors.length" style="color:#CC0000">
        <b>Error(s):</b>
        <div v-for="error in errors" v-bind:key="error">{{ error }}</div>
      </div>
      <div v-if="success" style="color:#3eac51">
        <div>{{ success }}</div>
      </div>

      <div class="corps-formulaire">
        <input type=hidden name="root" id="root" value='.ROOT_URL.'>
        <div>
          <label class="large" for="nom">{{ $t('formulaire.nom') }} :</label>
          <input type="text" v-model="nom" id="nom" name="nom"/>
        </div>
        <div>
          <label class="large" for="mail">{{ $t('formulaire.mail') }} :</label>
          <input type="email" v-model="mail" id="mail" name="mail"/>
        </div>
        <div>
          <label class="large" for="objet">{{ $t('formulaire.objet') }} :</label>
          <input type="text" v-model="objet" id="objet" name="objet"/>
        </div>
        <div>
          <label class="large" style="vertical-align:top;" for="message">{{ $t('formulaire.message') }} :</label>
          <textarea class="message-formulaire" type="text" v-model="message" id="message" name="message"></textarea>
        </div>
        <button type="submit" class="envoi">{{ $t('formulaire.envoyer') }}</button>

        <div style="font-size:11px;text-align:justify;margin:50px 0px 20px 0px" v-html="$t('formulaire.info_RGPD')"></div>

      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import VueCryptojs from 'vue-cryptojs'
 
Vue.use(VueCryptojs)

export default {
  data() {
    return{
      contactUrl: process.env.VUE_APP_CONTACT_URL,
      errors: [],
      success: process.env.CLE_SECRETE,
      nom: null,
      mail: null,
      objet: null,
      message: null,
      result_mail: null,
      timestamp: "",
    }
  },
  created() {
    setInterval(this.getNow(), 10000);
  },
  methods:{
    getNow: function() {
      this.timestamp = Date.now()
    },
    checkForm: function (e) {
      if (this.mail && this.message) {
        //return true;
        this.SendMail()
      }

      this.errors = [];

      if (!this.mail) {
        this.errors.push('Mail required.');
      }
      if (!this.message) {
        this.errors.push('Message required.');
      }

      e.preventDefault();
    },
    SendMail:function(){
      this.errors = []
      this.success = ""

      //cf : https://developer.okta.com/blog/2019/02/04/create-and-verify-jwts-in-php
      var tab_header = '{"typ" : "JWT","alg" : "HS256"}'
      var tab_payload = '{"nom" : "'+this.nom+'","email" : "'+this.mail+'","exp" : '+(this.timestamp+(5*60*1000))+'}'

      var base64UrlHeader = btoa(tab_header)
      var base64UrlPayload = btoa(tab_payload)
      var azerty = base64UrlHeader + "." + base64UrlPayload
      var hash = this.CryptoJS.HmacSHA256(azerty, process.env.VUE_APP_CLE_SECRETE);

      var base64UrlSignature = btoa(hash)

      var jwt = base64UrlHeader + "." + base64UrlPayload + "." + base64UrlSignature

      axios.post(this.contactUrl,{
          params: {
            email: this.mail,
            message: this.message,
            nom: this.nom,
            objet: this.objet, 
            jwt: jwt
          },
          withCredentials: true,
          credentials: 'same-origin',
        })
      .then(response => {
        // JSON responses are automatically parsed.
        this.result_mail = response.statusText

        if(this.result_mail == "OK"){
          this.success = this.$t('mail.succes')
        } else {
          this.errors = this.$t('mail.erreur')
        }
      })
    }
  }
}
</script>
